import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <FeaturesSection />
        <AboutSection />
        <CommentsSection />
        <IndexSection />
        <RankingSection />
        <CardsSection />
        <MediaSection />
        <AppSection />
        <FAQSection />
        <TopicsSection />
        <ContactSection />
        <CarouselSection />
      </main>
      <Footer />
    </div>
  );
}